import {computed} from 'mobx';
import {MeetingMode} from '@techsee/techsee-common/lib/constants/room.constants';
import get from 'lodash/get';
import {ITsEnvironmentDetect} from '@techsee/techsee-common/lib/helpers/ts-environment-detect';
import {ITsLocaleHelperService} from '../../services/ts-locale-helper/ts-locale-helper.service';
import {IChatApi} from '../../services/ts-chat-api/ChatApi';

export interface ITsLoaderController {
    readonly isConnected: boolean;
    readonly isIE11: boolean;
    readonly dir: string;
    readonly loaderText: string;
}

enum writeDirection {
    rtl = 'rtl',
    ltr = 'ltr'
}

export class TsLoaderController implements ITsLoaderController {
    private readonly chatApi: any;
    constructor(
        chatApi: IChatApi,
        private readonly environmentService: ITsEnvironmentDetect,
        private readonly tsLocaleHelper: ITsLocaleHelperService
    ) {
        this.chatApi = chatApi;
    }

    @computed
    get isConnected(): boolean {
        return this.chatApi?.client?.connected || false;
    }

    @computed
    get isIE11(): boolean {
        return this.environmentService?.isIE11() || false;
    }

    @computed
    get dir(): string {
        return this.tsLocaleHelper?.isRTL() ? writeDirection.rtl : writeDirection.ltr;
    }

    @computed
    get loaderText(): string {
        if (!this.chatApi?.areBothSidesConnected) {
            return 'MAIN.VIEW.RECOVERING_VIDEO';
        }

        if (get(this.chatApi, 'client.mode') === MeetingMode.screen) {
            return 'MAIN.VIEW.SCREEN_SHARE_LOADER_TEXT';
        }

        return 'MAIN.VIEW.LOADER_TEXT';
    }
}
